import React from 'react';
import { Line } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Tooltip, Legend } from 'chart.js';
import NotFound from '../ul/NotFound';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Tooltip, Legend);

const generateChartData = (data, label, color) => {
    if (!data || data.length === 0) return null;

    const counts = data.reduce((acc, entry) => {
        const date = new Date(entry.createdAt);
        const day = date.toLocaleDateString('en-GB'); // Format: dd/MM/yyyy
        acc[day] = (acc[day] || 0) + entry.count;
        return acc;
    }, {});

    const sortedData = Object.entries(counts)
        .map(([date, count]) => ({ x: date, y: count }))
        .sort((a, b) => new Date(a.x.split('/').reverse().join('-')) - new Date(b.x.split('/').reverse().join('-')));

    return {
        labels: sortedData.map((entry) => entry.x),
        datasets: [
            {
                label,
                data: sortedData,
                borderColor: color,
                backgroundColor: `${color}50`,
                fill: true,
                tension: 0.4,
            },
        ],
    };
};


const ChartComponent = ({ data, label, color }) => {
    const chartData = generateChartData(data, label, color);
    if (!chartData) return <NotFound />;

    return (
        <div className="bg-white p-6 rounded-lg shadow-lg flex items-center justify-center">
            <Line
                data={chartData}
                options={{
                    responsive: true,
                    maintainAspectRatio: false,
                    plugins: {
                        legend: { display: true, position: 'top' },
                        tooltip: {
                            callbacks: {
                                label: (tooltipItem) => {
                                    return `${tooltipItem.raw.y} Clicks on ${tooltipItem.raw.x}`;
                                }
                            }
                        }
                    },
                    scales: {
                        x: {
                            type: 'category',
                            title: { display: true, text: 'Date' },
                        },
                        y: { beginAtZero: true, title: { display: true, text: 'Count' } },
                    },
                }}
                height={350}
            />
        </div>
    );
};

const ViewChart = ({ ViewData }) => <ChartComponent data={ViewData} label="Views" color="#dc3545" />;
const ClickChart = ({ ClickData }) => <ChartComponent data={ClickData} label="Clicks" color="#28a745" />;

export { ClickChart, ViewChart };